
import {Component} from 'vue-property-decorator';
import {mixins} from 'vue-class-component';
import SnackbarMixin from '@/mixins/SnackbarMixin';
import LoadingMixin from '@/mixins/LoadingMixin';
import DialogUploadCertificate from '@/components/DialogUploadCertificate.vue';
import {swalSuccess} from '@/plugins/swal';

@Component({
  components: {DialogUploadCertificate},
})
export default class UploadIndex extends mixins(LoadingMixin, SnackbarMixin) {
  listCertification = [];
  dialogCetificate = false;

  async mounted() {
    await this.fecthCertification();
  }

  async deleteCertificate(values: any) {
    const confirmed = await this.$dialog.delete();

    if (confirmed) {
      try {
        const formData = {
          path: values.path,
        };
        const {message} = await this.$store.dispatch(
          'users/deleteCertificate',
          {id: values.id, payload: formData},
        );
        this.handleSuccess(message);
        this.fecthCertification();
      } catch (e) {
        this.catchError(e);
      }
    }
  }

  async saveFileCertificate(values: any) {
    try {
      this.startLoading('saving');
      const form = {
        file_url: values.files[0].url,
        path: values.files[0].path,
        title: values.title,
      };
      const res = await this.$store.dispatch('users/saveCertificate', form);
      if (res.status === 200) {
        swalSuccess.fire({
          title: 'Success!',
          text: `File ${values.title} Success to Upload`,
        });
        this.fecthCertification();
      }
      this.finishLoading('saving');
    } catch (e) {
      this.catchError(e);
    }
  }

  async fecthCertification() {
    try {
      this.startLoading('detail');
      const {data} = await this.$store.dispatch('users/getCertificate');
      this.finishLoading('detail');

      this.listCertification = data;
    } catch (e) {
      this.catchError(e);
    }
  }
}
